<template lang="pug">
el-dialog(
  :visible.sync="showModal"
  width="420px"
  :show-close="false"
  :close-on-click-modal="false"
  append-to-body
  custom-class="cadastro-confirm-dialog"
)
  .cadastro-confirm-dialog__header
    h2.cadastro-confirm-dialog__titulo {{ titulo }}
    button.cadastro-confirm-dialog__fechar(
      type="button"
      aria-label="Fechar"
      @click="cancelar"
    )
      img(
        src="@/assets/icons/cadastro/x.svg"
        alt=""
      )

  .cadastro-confirm-dialog__corpo
    img.cadastro-confirm-dialog__icone(
      :src="iconeSrc"
      alt=""
    )
    p.cadastro-confirm-dialog__mensagem {{ mensagem }}

  .cadastro-confirm-dialog__footer
    button.cadastro-confirm-dialog__btn.cadastro-confirm-dialog__btn--outline(
      type="button"
      @click="cancelar"
    )
      img.cadastro-confirm-dialog__btn-icone(
        src="@/assets/icons/cadastro/x.svg"
        alt=""
      )
      | {{ textoCancelar }}
    button.cadastro-confirm-dialog__btn.cadastro-confirm-dialog__btn--primary(
      type="button"
      @click="confirmar"
    )
      img.cadastro-confirm-dialog__btn-icone(
        src="@/assets/icons/cadastro/check-white.svg"
        alt=""
      )
      | {{ textoConfirmar }}
</template>

<script>
export default {
  name: 'CadastroConfirmDialog',
  props: {
    aberto: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: 'Atenção!'
    },
    mensagem: {
      type: String,
      required: true
    },
    textoCancelar: {
      type: String,
      default: 'Cancelar'
    },
    textoConfirmar: {
      type: String,
      default: 'Confirmar'
    },
    icone: {
      type: String,
      default: 'warning'
    }
  },
  computed: {
    showModal: {
      get () {
        return this.aberto
      },
      set () {
        this.$emit('cancelar')
      }
    },
    iconeSrc () {
      if (this.icone === 'warning') {
        return require('@/assets/icons/cadastro/alert-circle.svg')
      }
      return require('@/assets/icons/cadastro/info-circle.svg')
    }
  },
  methods: {
    cancelar () {
      this.$emit('cancelar')
    },
    confirmar () {
      this.$emit('confirmar')
    }
  }
}
</script>

<style lang="scss">
.cadastro-confirm-dialog {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  margin-top: 20vh !important;
  max-width: calc(100vw - 32px);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    color: #141414;
    padding: 20px;
  }
}
</style>

<style lang="scss" scoped>
.cadastro-confirm-dialog__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
}

.cadastro-confirm-dialog__titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  padding-right: 48px;
}

.cadastro-confirm-dialog__fechar {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  top: -1px;
  width: 40px;

  img {
    display: block;
    height: 16px;
    width: 16px;
  }
}

.cadastro-confirm-dialog__corpo {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.cadastro-confirm-dialog__icone {
  flex-shrink: 0;
  height: 20px;
  margin-top: 2px;
  width: 20px;
}

.cadastro-confirm-dialog__mensagem {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
}

.cadastro-confirm-dialog__footer {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}

.cadastro-confirm-dialog__btn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  height: 40px;
  justify-content: center;
  line-height: 20px;
  padding: 0 12px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &--outline {
    background: #ffffff;
    border: 1px solid #eaeaea;
    color: #141414;
  }

  &--primary {
    background: #1e174e;
    border: 1px solid transparent;
    color: #ffffff;
  }
}

.cadastro-confirm-dialog__btn-icone {
  display: block;
  height: 12px;
  width: 12px;
}

@media (max-width: 480px) {
  .cadastro-confirm-dialog__footer {
    flex-direction: column-reverse;
  }

  .cadastro-confirm-dialog__btn {
    width: 100%;
  }
}
</style>
